var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"text-capitalize custom-border g-signin2 px-2",staticStyle:{"width":"100%","display":"flex"},attrs:{"color":_vm.color,"dark":"","outlined":""},on:{"click":_vm.signIn}},[_c('v-icon',{attrs:{"left":"","size":"23"}},[_vm._v("mdi-google")]),_vm._v(" "+_vm._s(_vm.buttonPhrase)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }